import { useEffect, useState } from 'react';
import { applicationInsights } from '../../ApplicationInsights';
import { IDraw, IDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawApi } from '@apply/api';

export const useDrawBudgetWithDraw = (drawBudgetId: number, drawId: number) => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);

    const [drawBudget, set_drawBudget] = useState<IDrawBudget | undefined>(undefined);
    const [draw, set_draw] = useState<IDraw | undefined>(undefined);
    const [drawInfoLoaded, set_drawInfoLoaded] = useState<boolean>(false);

    useEffect(() => {
        const loadData = async () => {
            const response = await drawApi.getDrawBudget(drawBudgetId);
            if (response.statusCode !== 200) {
                set_drawInfoLoaded(true);
                return;
            }

            const budgetResult = response.result;
            set_drawBudget(budgetResult);

            const drawResult = budgetResult.draws.find(draw => draw.id == drawId);
            if (!drawResult) {
                set_drawInfoLoaded(true);
                throw new Error('Could not find specified draw.');
            }

            set_draw(drawResult);
            set_drawInfoLoaded(true);
        };

        loadData();
    }, [drawBudgetId, drawId]);

    return {
        drawBudget,
        draw,
        drawInfoLoaded,
    };
};
